import { useRef, useEffect } from 'react';

export const useHorizontalScrollForDesktop = () => {
  const targetComponentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const touchStattus = 'ontouchstart' in window;

    const targetComponent = targetComponentRef?.current as HTMLDivElement;

    if (targetComponentRef && !touchStattus) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      const mouseDown = (e: MouseEvent) => {
        isDown = true;
        startX = e?.pageX - targetComponent!.offsetLeft;
        scrollLeft = targetComponent?.scrollLeft as number;
      };

      const mouseLeave = () => {
        isDown = false;
        targetComponent?.classList?.remove('scroll-drag');
      };

      const mouseUp = () => {
        isDown = false;
        targetComponent?.classList?.remove('scroll-drag');
      };

      const mouseMove = (e: MouseEvent) => {
        if (!isDown) return;
        const x = e?.pageX - targetComponent!.offsetLeft;
        const step = x - startX;
        targetComponent!.scrollLeft = scrollLeft - step;
        targetComponent?.classList?.add('scroll-drag');
      };

      targetComponent?.addEventListener('mouseup', mouseUp);
      targetComponent?.addEventListener('mouseleave', mouseLeave);
      targetComponent?.addEventListener('mousemove', mouseMove);
      targetComponent?.addEventListener('mousedown', mouseDown);

      return function cleanup() {
        targetComponent?.removeEventListener('mouseup', mouseUp);
        targetComponent?.removeEventListener('mouseleave', mouseLeave);
        targetComponent?.removeEventListener('mousemove', mouseMove);
        targetComponent?.removeEventListener('mousedown', mouseDown);
      };
    }
  }, [targetComponentRef]);
  return { targetComponentRef };
};
